import { onUnmounted, ref, computed } from 'vue';

export const useRating = () => {
	const ratingUnavailable = ref(false);
	const ratingMoreInfo = ref(false);
	const ratingSuccess = ref(false);
	const ratingClosed = ref(false);
	function ratingUnavailableCallback() {
		ratingUnavailable.value = true;
	}
	function ratingMoreInfoCallback() {
		ratingMoreInfo.value = true;
	}
	function ratingSuccessCallback() {
		ratingSuccess.value = true;
	}
	function setRatingClosed() {
		ratingClosed.value = true;
	}
	window.addEventListener('rating-unavailable', ratingUnavailableCallback);
	window.addEventListener('rating-more-info', ratingMoreInfoCallback);
	window.addEventListener('rating-success', ratingSuccessCallback);
	window.addEventListener('dces-submitted', ratingSuccessCallback);
	onUnmounted(() => {
		window.removeEventListener('rating-unavailable', ratingUnavailableCallback);
		window.removeEventListener('rating-more-info', ratingMoreInfoCallback);
		window.removeEventListener('rating-success', ratingSuccessCallback);
		window.removeEventListener('dces-submitted', ratingSuccessCallback);
	});
	const showPrecedingForm = computed(() => (!ratingMoreInfo.value && !ratingSuccess.value) || ratingClosed.value || ratingUnavailable.value);
	return { ratingUnavailable, setRatingClosed, showPrecedingForm, ratingSuccess };
};
